export const Kletsk = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.027395153208545, 52.77633678438343],
            [27.02809142818859, 52.779285085629624],
            [27.02809142818859, 52.78522503736508],
            [27.031216165802164, 52.79386351954298],
            [27.03434090431398, 52.79980148134382],
            [27.03657285936731, 52.80654818118052],
            [27.03925120704821, 52.8157220130654],
            [27.04211682112242, 52.819433100656056],
            [27.03880481531877, 52.821656990494375],
            [27.03478729514495, 52.824624175283475],
            [27.028984209850705, 52.8270517210795],
            [27.01827082272058, 52.8289397188488],
            [27.007557434692103, 52.82920942588561],
            [26.99639765583254, 52.830288237832065],
            [26.988809006315932, 52.83001853749266],
            [26.9843450953112, 52.827591157463246],
            [26.977202836625565, 52.82732143983719],
            [26.970060577939933, 52.830288237832065],
            [26.962471928423156, 52.83352451401879],
            [26.956222452297936, 52.83487289068353],
            [26.94684823855897, 52.835142561427574],
            [26.93747402392171, 52.83676054856227],
            [26.934795677139164, 52.83864812385974],
            [26.933456503747948, 52.84296227440285],
            [26.933456503747948, 52.84781518160872],
            [26.933456503747948, 52.85212842089038],
            [26.932563721187705, 52.85455442976132],
            [26.929438983574187, 52.858866999991506],
            [26.924528680840126, 52.861831643382516],
            [26.91872559554571, 52.86533505187333],
            [26.91872559554571, 52.87368819165317],
            [26.91872559554571, 52.878537663549764],
            [26.916493640492376, 52.88311722263427],
            [26.910244164366986, 52.886349561259294],
            [26.89997716716954, 52.89281351613249],
            [26.891049344261717, 52.89846868606145],
            [26.884799868136326, 52.90412311754932],
            [26.879889565402323, 52.90977681172063],
            [26.878550392010936, 52.915698937321906],
            [26.87944317457135, 52.921889385607244],
            [26.884799868136326, 52.927271664340026],
            [26.889263780039357, 52.931577005243355],
            [26.895513256164747, 52.93507477993154],
            [26.897298820387107, 52.937765183575266],
            [26.897745212116376, 52.94422146904543],
            [26.895066864435478, 52.948525124521495],
            [26.895513256164747, 52.95175258489172],
            [26.903548296512497, 52.954441951601325],
            [26.909351381806744, 52.9582067837224],
            [26.908904990975827, 52.96224016851619],
            [26.903994688241767, 52.96519774508903],
            [26.90042355889898, 52.96923047774084],
            [26.90042355889898, 52.97272520874992],
            [26.903548296512497, 52.97702602815741],
            [26.908904990975827, 52.9821326946776],
            [26.908012208415585, 52.985895115701055],
            [26.90220912312111, 52.98831364232433],
            [26.89462047360456, 52.988851073815056],
            [26.884353477305353, 52.989925917817175],
            [26.873640089276932, 52.992344218215464],
            [26.85667722602136, 52.99664308494988],
            [26.844624664601554, 53.00040424216883],
            [26.832572104080214, 53.003896451596574],
            [26.817394804148705, 53.008999942484934],
            [26.812930893143744, 53.01141717476827],
            [26.808913372969982, 53.016519776481516],
            [26.808466981240713, 53.0213532633328],
            [26.811145328023315, 53.02430679447605],
            [26.81605563075732, 53.0291394095168],
            [26.821858716051736, 53.03236085172381],
            [26.828108192177126, 53.03692414979497],
            [26.82900097473737, 53.04229211748543],
            [26.82498345366531, 53.04470748535806],
            [26.820073151829376, 53.045244214915215],
            [26.813823675704157, 53.04551257772755],
            [26.806681417018524, 53.04819611017871],
            [26.808466981240713, 53.05141612879828],
            [26.81248450231277, 53.05329436225168],
            [26.820073151829376, 53.056782292600474],
            [26.82319788944295, 53.05973339709618],
            [26.82230510688271, 53.06268429999528],
            [26.818733977539864, 53.06563500076402],
            [26.819180369269134, 53.070462984463916],
            [26.820965933491493, 53.07421770849339],
            [26.824090672003365, 53.077972105142976],
            [26.82676901878574, 53.08172617442489],
            [26.83167932151997, 53.086016138091],
            [26.833464885742103, 53.09067026580726],
            [26.834036266365104, 53.09410155780944],
            [26.830536215007726, 53.09798159991254],
            [26.83032229231577, 53.09821874759018],
            [26.825751247331823, 53.09941952023843],
            [26.819466059580748, 53.100105660989755],
            [26.8120381105835, 53.10027719446771],
            [26.80632430435361, 53.10079179079747],
            [26.801181877848535, 53.10267859188053],
            [26.794039619162902, 53.105765905166436],
            [26.785754600129565, 53.10593741607374],
            [26.778326651132375, 53.10216401812164],
            [26.774612676184688, 53.09718948721604],
            [26.769184560266353, 53.092900636732],
            [26.762327991892107, 53.091528114458924],
            [26.751471759157084, 53.092900636732],
            [26.744043810159894, 53.09787566353464],
            [26.740329836110504, 53.10405075847666],
            [26.735187410503556, 53.107823991453756],
            [26.729759293686925, 53.10936749113364],
            [26.72204565437829, 53.10885299739573],
            [26.713760634446658, 53.10559439357519],
            [26.70918958946271, 53.103193159483794],
            [26.70376147264608, 53.101306381510994],
            [26.698333356727744, 53.099934126827975],
            [26.690334027107724, 53.09907644575884],
            [26.68204900717609, 53.100620259371624],
            [26.660336541705874, 53.108166996169984],
            [26.649765999282295, 53.113997658334426],
            [26.636052863432326, 53.120170438904665],
            [26.622054036372504, 53.12497087731765],
            [26.610340732703094, 53.1278851681933],
            [26.605198307096146, 53.130456436734676],
            [26.596056216230124, 53.13474154296097],
            [26.585485673806545, 53.140739973542566],
            [26.580057556989857, 53.14433863009094],
            [26.57348667982552, 53.14536676214442],
            [26.57062977581228, 53.141254085717776],
            [26.57348667982552, 53.13628407639584],
            [26.575772202317353, 53.13234193642512],
            [26.573200989513964, 53.12857085484745],
            [26.56748718238572, 53.12548517874649],
            [26.557202330273697, 53.12497087731765],
            [26.549488690965063, 53.12754232076355],
            [26.544346265358115, 53.13148490161274],
            [26.53663262604948, 53.13285614910751],
            [26.52863329642946, 53.13148490161274],
            [26.52177672895357, 53.130285023618285],
            [26.517205683071325, 53.130113609818125],
            [26.504920998778914, 53.1335417564448],
            [26.50034995289667, 53.13851208301219],
            [26.49777874009328, 53.142282291608524],
            [26.49549321760128, 53.14502405419455],
            [26.494350456355335, 53.14913636910768],
            [26.48806526860409, 53.15136370914206],
            [26.485208365489086, 53.15119237943645],
            [26.480637319607013, 53.14982171718111],
            [26.476637655246066, 53.149650381322886],
            [26.47120953932773, 53.15119237943645],
            [26.467781254691488, 53.15410489145984],
            [26.467495564380044, 53.15598935332673],
            [26.464352970953485, 53.15873024033118],
            [26.456925021956465, 53.16027191236941],
            [26.44549740859827, 53.158558940020214],
            [26.442069124860495, 53.15444752694458],
            [26.440354982093254, 53.152734322176514],
            [26.434641175863305, 53.15016438684671],
            [26.432641343682917, 53.149307707016874],
            [26.436069627420864, 53.14399591393703],
            [26.439212220847253, 53.141254085717776],
            [26.445211718286885, 53.13645546558098],
            [26.45206828666096, 53.13199912455127],
            [26.457782092890852, 53.126513762063325],
            [26.46722885233652, 53.118577045594236],
            [26.471797463182384, 53.118577045594236],
            [26.4816356200879, 53.1110615992136],
            [26.47626935284842, 53.104618742760806],
            [26.47626935284842, 53.098174921335556],
            [26.482529997661345, 53.08850737841294],
            [26.495945666659225, 53.08689591021812],
            [26.508466958083773, 53.08743307257822],
            [26.51651635894285, 53.08850737841294],
            [26.522777004655097, 53.083672793065034],
            [26.52367138312792, 53.07776311677452],
            [26.526354515848368, 53.06916577607984],
            [26.529932027940788, 53.06271664505721],
            [26.530826405514233, 53.05089072832459],
            [26.529037649467966, 53.04497655272576],
            [26.520988248608887, 53.041750296938744],
            [26.512044469276987, 53.041750296938744],
            [26.505783824464118, 53.04282574221435],
            [26.49773442270549, 53.047127256218005],
            [26.484318753707555, 53.05142834034581],
            [26.47448059680221, 53.05142834034581],
            [26.463748062323305, 53.04820256749463],
            [26.461959306277095, 53.041750296938744],
            [26.46643119594313, 53.03529706051103],
            [26.468219951089964, 53.02669124370607],
            [26.469114329562785, 53.020773747810324],
            [26.46732557351652, 53.01324121610935],
            [26.465536818369515, 53.00893632065487],
            [26.456593039037614, 53.00516918650891],
            [26.449438015751923, 53.00409280144174],
            [26.438705480373642, 53.00624554459637],
            [26.427972945894908, 53.00624554459637],
            [26.424395433802317, 53.001401722311755],
            [26.419029166562837, 52.99332747858034],
            [26.410085387230936, 52.99117409151114],
            [26.402930363945302, 52.99063572855607],
            [26.393092207939162, 52.9874054069341],
            [26.391303451892952, 52.97932854617562],
            [26.39756409670582, 52.97448170486683],
            [26.406507876037722, 52.96263158198195],
            [26.419029166562837, 52.950239342371844],
            [26.437811101900877, 52.94269450165001],
            [26.443177370039677, 52.93245297002869],
            [26.443177370039677, 52.925983384825486],
            [26.447649259705713, 52.920591325929024],
            [26.45927617265727, 52.917355768454115],
            [26.463748062323305, 52.91411996816203],
            [26.465536818369515, 52.908187040799476],
            [26.461959306277095, 52.90117435231463],
            [26.449438015751923, 52.89847686191774],
            [26.436022347653193, 52.89470009243536],
            [26.429761701941118, 52.88660590893568],
            [26.429761701941118, 52.878510213675554],
            [26.421712301081868, 52.87365207058667],
            [26.410085387230936, 52.86771360160151],
            [26.402930363945302, 52.86069436245498],
            [26.398458474279266, 52.85259382974158],
            [26.398458474279266, 52.84503196755145],
            [26.402930363945302, 52.84071031233111],
            [26.413662899323413, 52.835847936133405],
            [26.424395433802317, 52.83044465819455],
            [26.434233591607153, 52.829904293348534],
            [26.438705480373642, 52.82666196307923],
            [26.441105296429214, 52.820861381985026],
            [26.441388613993468, 52.82017657678773],
            [26.441388613993468, 52.81314964933699],
            [26.445860503659503, 52.80666224586605],
            [26.45390990451864, 52.80666224586605],
            [26.46285368474986, 52.81152788930069],
            [26.47716373132124, 52.82017657678773],
            [26.501311934798082, 52.83746878965309],
            [26.505783824464118, 52.84503196755145],
            [26.520093871035442, 52.85151364413946],
            [26.529932027940788, 52.85043343155769],
            [26.536192673653034, 52.84287119435021],
            [26.541558939993138, 52.83908958111931],
            [26.55408023141763, 52.83962983175144],
            [26.56839027798901, 52.84935319289559],
            [26.574650923701256, 52.85583422466976],
            [26.58180594698689, 52.87095286698138],
            [26.589855347846196, 52.88390751202212],
            [26.597904748705275, 52.889843764178465],
            [26.608637284083386, 52.89092299559985],
            [26.612214795276657, 52.88606624286297],
            [26.617581063415457, 52.878510213675554],
            [26.62831359789442, 52.87473170490426],
            [26.644412400511953, 52.87095286698138],
            [26.655144934990858, 52.87149272101237],
            [26.664088715222135, 52.87095286698138],
            [26.67482124970104, 52.86447409430406],
            [26.67482124970104, 52.859074376781166],
            [26.679293139366905, 52.852053740088195],
            [26.682870651459552, 52.84989331582403],
            [26.68913129627242, 52.84989331582403],
            [26.697180698030877, 52.84881306367208],
            [26.717751389415128, 52.84773278454054],
            [26.730272679940242, 52.84719263463245],
            [26.74368834893818, 52.84719263463245],
            [26.753526505843695, 52.84719263463245],
            [26.75799839550973, 52.84287119435021],
            [26.763364662748984, 52.832606050129186],
            [26.763364662748984, 52.82612155056927],
            [26.76873093088784, 52.81963608423803],
            [26.77678033174709, 52.81423078822047],
            [26.783040977459166, 52.80504024391229],
            [26.78393535503278, 52.80017387472469],
            [26.784829733505376, 52.793684535912575],
            [26.79019599984565, 52.78935777164395],
            [26.798245401604163, 52.78448964787907],
            [26.808083558509452, 52.77907998205569],
            [26.81613295936876, 52.77421070805781],
            [26.824182361127214, 52.770423117932694],
            [26.831337384412905, 52.76879976519706],
            [26.842964296465198, 52.76663519955497],
            [26.85280245426992, 52.76879976519706],
            [26.870690012933892, 52.77204641131294],
            [26.88231692588539, 52.77475176538172],
            [26.893049460364352, 52.77204641131294],
            [26.897521350030388, 52.765011704726476],
            [26.901993238797047, 52.759058372645825],
            [26.909148262982058, 52.75635204281269],
            [26.92703582164603, 52.753645545705524],
            [26.935979600078554, 52.75526946411452],
            [26.952078402696316, 52.75202156704182],
            [26.95923342508263, 52.74660786596024],
            [26.971754717406327, 52.7439007627101],
            [26.976226606172986, 52.747690659596344],
            [26.979804118265577, 52.75418685843687],
            [26.983381629458677, 52.759058372645825],
            [26.992325408790748, 52.76609404150685],
            [26.999480432076382, 52.76879976519706],
            [27.01110734502811, 52.77204641131294],
            [27.020051123460632, 52.7752928164104],
            [27.0272061476457, 52.776374896883965],
            [27.027395153208545, 52.77633678438343],
          ],
        ],
      },
      properties: {
        shapeName: "Kletsk",
        shapeISO: "",
        shapeID: "67162791B94687657655016",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
